import { FormRow, Alert } from '../../components'
import { useAppContext } from '../../context/appContext'
import Wrapper from '../../assets/wrappers/DashboardFormPage'
import { Link, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react';

const initialLocalState = {
    isSubmited: false,
}

const AddInformationItem = () => {
    const [localStateValues, setLocalStateValues] = useState(initialLocalState)

    const { isSubmited, } = localStateValues

    const navigate = useNavigate();

    const {
        isLoading,
        isEditing,
        showAlert,
        displayAlert,
        alertType,
        month,
        year,
        electricity,
        commentElectricity,
        photovoltaic,
        commentPhotovoltaic,
        water,
        commentWater,
        heating,
        commentHeating,
        handleChange,
        clearValues,
        createInformationItem,
        editInformationItem,
    } = useAppContext()

    useEffect(() => {
        if (isSubmited && alertType === 'success') {
            navigate('/all-informationItems')
        }
    }, [displayAlert, alertType])

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!month || !year) {
            displayAlert('Please provide a date')
            return
        }

        var inputDate = new Date(year, month - 1)

        if (inputDate.getTime() > new Date().getTime()) {
            displayAlert('Das Datum darf nicht in der Zukunft sein!')
            return;
        }

        if (!electricity && !photovoltaic && !water && !heating) {
            displayAlert('Zum Speichern bitte mindestens einen Wert eingeben')
            return
        }
        if (isEditing) {
            editInformationItem()
            return
        }

        setLocalStateValues({ isSubmited: true })

        createInformationItem()
    }

    const handleInformationItemInput = (e) => {
        const name = e.target.name
        const value = e.target.value

        handleChange({ name, value })
    }

    return (
        <Wrapper>
            <form className='form' onSubmit={handleSubmit}>
                <h3>{isEditing ? 'edit informationItem' : 'Eintrag hinzufügen'}</h3>
                {showAlert && <Alert />}
                <div className='form-center'>
                    <div className='form-row'>
                        <label htmlFor={"month"} className='form-label'>
                            Monat
                        </label>
                        <select className='form-input' name="month" defaultValue={month} onChange={handleInformationItemInput}>
                            <option value="1">Januar</option>
                            <option value="2">Februar</option>
                            <option value="3">März</option>
                            <option value="4">April</option>
                            <option value="5">Mai</option>
                            <option value="6">Juni</option>
                            <option value="7">Juli</option>
                            <option value="8">August</option>
                            <option value="9">September</option>
                            <option value="10">Oktober</option>
                            <option value="11">November</option>
                            <option value="12">Dezember</option>
                        </select>
                    </div>
                    <FormRow
                        type="int"
                        labelText={"Jahr"}
                        name="year"
                        value={year}
                        min={"0"}
                        handleChange={handleInformationItemInput}
                    />
                    <FormRow
                        type="float"
                        labelText={"Strom"}
                        name="electricity"
                        value={electricity}
                        min={"0"}
                        handleChange={handleInformationItemInput}
                    />
                    <FormRow
                        type="text"
                        labelText={"Kommentar Strom"}
                        name="commentElectricity"
                        maxLength={99}
                        value={commentElectricity}
                        handleChange={handleInformationItemInput}
                    />
                    <FormRow
                        type="float"
                        labelText={"Photovoltaik"}
                        name="photovoltaic"
                        value={photovoltaic}
                        min={"0"}
                        handleChange={handleInformationItemInput}
                    />
                    <FormRow
                        type="text"
                        labelText={"Kommentar Photovoltaik"}
                        name="commentPhotovoltaic"
                        maxLength={99}
                        value={commentPhotovoltaic}
                        handleChange={handleInformationItemInput}
                    />
                    <FormRow
                        type="float"
                        labelText={"Wasser"}
                        name="water"
                        value={water}
                        min={"0"}
                        handleChange={handleInformationItemInput}
                    />
                    <FormRow
                        type="text"
                        labelText={"Kommentar Wasser"}
                        name="commentWater"
                        maxLength={99}
                        value={commentWater}
                        handleChange={handleInformationItemInput}
                    />
                    <FormRow
                        type="float"
                        labelText={"Heizung"}
                        name="heating"
                        value={heating}
                        min={"0"}
                        handleChange={handleInformationItemInput}
                    />
                    <FormRow
                        type="text"
                        labelText={"Kommentar Heizung"}
                        name="commentHeating"
                        maxLength={99}
                        value={commentHeating}
                        handleChange={handleInformationItemInput}
                    />
                    <div className='btn-container'>
                        <button
                            type="submit"
                            className='btn btn-block submit-btn'
                            disabled={isLoading}>
                            Speichern
                        </button>
                        <Link
                            to="/all-informationItems"
                            className='btn btn-block btn-danger'
                            onClick={(e) => {
                                clearValues()
                            }}>
                            Abbrechen
                        </Link>
                    </div>
                </div>
            </form>
        </Wrapper>
    )
}

export default AddInformationItem